import { ValueItem } from './types';
import {ErrorField} from "../validate";

interface Value {
  controlid: string;
  value: any;
  control: any;
}

export function* validate(state: ValueItem[], allValues: Value[], validateEmptyRequired: boolean): Iterable<ErrorField> {
  const valueNotCloused = Array.from(state).find((t: any) => !t.closed);
  if (valueNotCloused) {
    yield { controlId: valueNotCloused.id, control: valueNotCloused, error: {message: 'Раздел должен быть закрыт', isFrontValidation: true}};
    return;
  }
  for(const element of state) {
    for(const item of element.items) {
      const exist = allValues.some(t => t.controlid === item.name);
      if(!exist && validateEmptyRequired) {
        yield { controlId: item.name, control: item, error: {message: 'Не заполнено обязательное поле', isFrontValidation: true}};
      } else {
        yield { controlId: item.name, control: item, error: undefined};
      }
    }
  }
  return;
}